<template>
	<div id="app" class="bg-gray-900">
		<NavBar />
		<transition name="fade" mode="out-in">
			<router-view class="w-full bg-gray-900 pb-20"></router-view>
		</transition>
	</div>
</template>

<script>
import NavBar from './components/navBar.vue';

export default {
	name: 'App',
	components: {
		NavBar
	},
	methods: {
		toggle: () => {
			document.querySelector('.nav-container').classList.toggle('shown');
		}
	}
};
</script>
